import { interval, Subscription } from 'rxjs';
import { distinctUntilChanged, filter, map } from 'rxjs/operators';

import { AfterViewInit, Directive, ElementRef, EventEmitter, OnDestroy, Output } from '@angular/core';

@Directive({
  selector: '[sharedInView]',
})
export class SharedInViewDirective implements AfterViewInit, OnDestroy {
  @Output() sharedInView = new EventEmitter();

  // A placeholder for all subscription so we can unsubscribe all of them in the ondestroy Methods.
  subscriptions = new Subscription();

  constructor(private el: ElementRef) {}

  ngAfterViewInit(): void {
    this.subscriptions.add(
      interval(200)
        .pipe(
          // Is elementId scrolled for more than 50 from top?
          map(() => {
            return this.el.nativeElement.getBoundingClientRect();
          }),
          map((res: any) => {
            if (res.top <= window.innerHeight && res.bottom >= 0) {
              return true;
            }
            return false;
          }),
          distinctUntilChanged(),
          filter((res) => res === true),
        )
        .subscribe(() => {
          this.sharedInView.emit();
        }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
